import { FormPropertyKey } from "src/app/models/form-property-key";
import { User } from "src/app/models/user";
import { ProspectKey } from "src/app/models/prospect-key";

export class Form{

  // 共通
  static EnableTrue = 1;
  static EnableFalse = 2;

  static TypeExpand = 1;
  static TypeOverlay = 2;

  static ExpandSendCompleteTypeRedirect = 1;
  static ExpandSendCompleteTypeScreen = 2;  
  static OverlaySendCompleteTypeNone = 3;
  static OverlaySendCompleteTypeScreen = 4;

  id: number;
  hash: string;
  enable: 1 | 2 = 2;
  name: string = "動画フォーム";
  type: 1 | 2 = 2;
  title: string;
  description: string;
  formPropertyKeys: Array<FormPropertyKey> = [];

  sendCompleteType: 1 | 2 | 3 | 4; // CompleteTypeNone, CompleteTypeScreen
  sendCompleteTitle: string;
  sendCompleteDescription: string;
  sendCompleteRedirectUrl: string;
  sendCompleteNotifyUsers: Array<User> = [];

  // Overlay
  static ShowTimingFirst = "first";
  static ShowTimingLast = "last";
  static WithSkipFalse = 1;
  static WithSkipTrue = 2;
  static IsVisitorOnlyTrue = 1;
  static IsVisitorOnlyFalse = 2;

  isVisitorOnly: 1 | 2 = 1;
  showTiming: "first" | "last" | number = "first";
  withSkip: 1 | 2 = 1;
  sendBtnTitle: string = "送信";
  
  // Expand




  constructor(object: any = null){
    if(! object){
      return;
    }
    this.setObject(object);
  }
  
  setObject(object: any){

    console.log(object);

    if(object['id'] != null){
      this.id = object['id'];
    }
    if(object['hash'] != null){
      this.hash = object['hash'];
    }
    if(object['enable'] != null){
      this.enable = object['enable'];
    }
    if(object['name'] != null){
      this.name = object['name'];
    }
    if(object['type'] != null){
      this.type = object['type'];
    }
    if(object['title'] != null){
      this.title = object['title'];
    }
    if(object['description'] != null){
      this.description = object['description'];
    }
    if(object['sendCompleteType'] != null){
      this.sendCompleteType = object['sendCompleteType'];
    }
    if(object['sendCompleteRedirectUrl'] != null){
      this.sendCompleteRedirectUrl = object['sendCompleteRedirectUrl'];
    }
    if(object['sendCompleteTitle'] != null){
      this.sendCompleteTitle = object['sendCompleteTitle'];
    }
    if(object['sendCompleteDescription'] != null){
      this.sendCompleteDescription = object['sendCompleteDescription'];
    }
    if(object['sendCompleteNotifyUsers'] != null){
      this.sendCompleteNotifyUsers = object['sendCompleteNotifyUsers'].map((userObject) => {return new User(userObject)});
    }

    if(object['formPropertyKeys'] != null){
      this.formPropertyKeys = object['formPropertyKeys'].map((formPropertyKeyObject) => {
        return new FormPropertyKey(formPropertyKeyObject);
      });
    }

    // Overlay
    if(object['isVisitorOnly'] != null){
      this.isVisitorOnly = object['isVisitorOnly'];
    }
    if(object['showTiming'] != null){
      if(object['showTiming'] == "first" || object['showTiming'] == "last"){
        this.showTiming = object['showTiming'];
      }
      else{
        this.showTiming = Number(object['showTiming']);
      }
    }
    if(object['withSkip'] != null){
      this.withSkip = object['withSkip'];
    }
    if(object['sendBtnTitle'] != null){
      this.sendBtnTitle = object['sendBtnTitle'];
    }

  }

}